import React, { Component } from 'react';
import CharSelectSection from '../../components/GamePage/CharSelectSection/CharSelectSection'
export default class CharSelectPage extends Component {
    render() {
        return (
            <CharSelectSection></CharSelectSection>
        )
    }
}